import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { TextButton, IconType, ButtonType } from '@checkmarx/cx-ui';
import SAMLIDPItemContainer from './itemContainer';
import AddEditSAMLFormContainer from '../addEditForm';
import { LdapEditMode } from '../../../services/enums/ldap';
import ConfirmationDialog from '../../portal/dialogs/confirmationDialog';
import ErrorDialog from '../../portal/dialogs/errorDialog';

@inject('translationsStore', 'samlStore')
export default class SAMLIDPItemsContainer extends Component {

    samlStore = this.props.samlStore;
    errorDialogTitle;
    errorDialogMessage;
    t = this.props.translationsStore.translate;

    state = {
        add: false,
        openLeaveFormDialog: false,
        openErrorDialog: false
    };

    openAddIdpForm = () => {

        if (this.samlStore.isEditMode === true) {
            
            this.errorDialogTitle = this.t('ONLY_ONE_IDP_CAN_BE_EDITED_AT_A_TIME');
            this.errorDialogMessage = this.t('SAVE_OR_CANCEL_THE_CURRENT_FORM_AND_TRY_AGAIN');
            this.openErrorDialog();
        }
        else {

            this.setState({
                add: true
            });

            this.samlStore.resetForm();
            this.samlStore.toggleIsEditMode();
        }
    }

    cancelAdd = () => {
        
        this.openLeaveFormDialogHandler();
    }

    openLeaveFormDialogHandler = () => {

        this.setState({ 
            openLeaveFormDialog: true,
        });
    }

    leaveFormDialogHandler = () => {

        this.setState({ 
            openLeaveFormDialog: false,
            add: false
        });

        this.samlStore.toggleIsEditMode();
    }

    stayFormDialogHandler = () => {

        this.setState({ 
            openLeaveFormDialog: false
        });
    }

    deleteSAMLIdentityProvider = idpId => {

        this.samlStore.deleteSAMLIdentityProvider(idpId);
    }

    openErrorDialog = () => {

        this.setState({ 
            openErrorDialog: true
        }); 
    }

    closeErrorDialog = () => {

        this.setState({ 
            openErrorDialog: false
        }); 
    }

    closeForm = _ => this.setState({ 
        add: false
    });

    componentDidMount() {

        this.samlStore.setIsEditMode(false);
    }

    render() {

        const { items } = this.props;
        const t = this.props.translationsStore.translate;

        return(
            <div>
                {
                    items.map(item => {

                        return <SAMLIDPItemContainer 
                                    key={item.id}
                                    id={item.id}
                                    name={item.name}
                                    active={item.active}
                                    issuer={item.issuer}
                                    isManualManagement={item.isManualManagement}
                                    translations={{
                                        edit: t('EDIT'),
                                        delete: t('DELETE'),
                                        issuer: t('ISSUER'),
                                        userAuthorization: t('USER_AUTHORIZATION'),
                                        active: t('ACTIVE'),
                                        notActive: t('NOT_ACTIVE'),
                                        manualAuthorization: t('APPLICATION_AUTHORIZATION'),
                                        automaticAuthorization: t('IDP_AUTHORIZATION'),
                                        userAuthotizationManagment: t('USER_AUTHORIZATION_MANAGEMENT')
                                    }}
                                    deleteSAMLIdentityProvider={this.deleteSAMLIdentityProvider}
                                />
                    })
                }
                {
                    this.state.add ? <div
                                        className='ldap-add-form-wrapper'
                                        style={{marginTop: 25}}
                                    >
                                        <AddEditSAMLFormContainer
                                            dataCy='saml-add-form-wrapper'
                                            editMode={LdapEditMode.add}
                                            cancelButtonHandler={this.cancelAdd}
                                            closeForm={this.closeForm}
                                        />
                                    </div> 
                                        : null
                }
                {
                    this.state.add ? null : <div
                                                style={{marginTop: 30}}
                                            >
                                                <TextButton 
                                                    dataCy='add-saml-identity-provider-button'
                                                    iconType={IconType.add}
                                                    text={t('ADD_NEW_SAML_IDENTITY_PROVIDER')}
                                                    onClick={this.openAddIdpForm}
                                                />
                                            </div>
                }
                <ConfirmationDialog 
                    open={this.state.openLeaveFormDialog}
                    onButtonClick={this.stayFormDialogHandler}
                    onCancelClick={this.leaveFormDialogHandler}
                    closeClick={this.stayFormDialogHandler}
                    buttonText={t('STAY')}
                    cancelButtonText={t('LEAVE')}
                    titleText={t('CONFIRMATION')}
                    contentText={t('ARE_YOU_SURE_YOU_WANT_TO_LEAVE_THIS_FOR_WITHOUT_SAVING')}
                />
                <ErrorDialog
                    show={this.state.openErrorDialog}
                    onConfirm={this.closeErrorDialog}
                    deleteButtonText={t('CLOSE')}
                    closeDeleteDialog={this.closeErrorDialog}
                    titleText={this.errorDialogTitle}
                    contentText={this.errorDialogMessage}
                />
            </div>
        );
    }
}